<div class="general-body">
        <div class="body-container">

            <div class="vendor-application">
                <div class="vendor-title">
                    <h4>
                        Profile
                    </h4>
                </div>
                <div class="container vendor-status-road">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb d-flex align-items-center">
                            <li>
                                <a [routerLink]="['/home']" class="dashboard-road breadcrumb-link">
                                    Dashboard
                                    <svg class="chevv"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        fill="currentColor"
                                        class="bi bi-chevron-right"
                                        viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <span class="status-road">
                                    Profile Page
                                    <svg class="chevv"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        fill="currentColor"
                                        class="bi bi-chevron-right"
                                        viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                </span>
                            </li>
                            <li aria-current="page">
                                <span class="vendor-apllication-road">
                                    Edit Profile
                                </span>
                            </li>
                        </ol>
                    </nav>
                </div>

            </div>

            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="background-image">
                        <img src="../../../../../assets/img/Backkground.png" alt="Background Image" class="background-pic">
                        <div class="profile-pic-zoom profile-avatar-svg">
                            <svg width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="90" cy="90" r="90" fill="url(#gradient)"/>
                                <circle cx="90" cy="70" r="35" fill="white" opacity="0.9"/>
                                <path d="M50 140C50 120 68 105 90 105C112 105 130 120 130 140" fill="white" opacity="0.9"/>
                                <defs>
                                    <linearGradient id="gradient" x1="0" y1="0" x2="180" y2="180" gradientUnits="userSpaceOnUse">
                                        <stop offset="0%" stop-color="#532E60"/>
                                        <stop offset="100%" stop-color="#8e6b8e"/>
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                    </div>

                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-md-4">
                                <!-- Empty space to push content to center and right -->
                            </div>
                            <div class="col-md-4 text-center user-name">
                                <div class="bio">
                                    <h6 class="title-bio fw-bold">{{vendor?.vendorName || ''}}</h6>
                                    <p class="bio-details">{{vendor?.email || ''}}</p>
                                </div>
                            </div>
                            <div class="col-md-4 text-right d-flex justify-content-end">

                                <!-- <div class="change-button">
                                  <a class="btn btn-save change-btn">
                                      <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path opacity="0.4" d="M17.7969 19.4375H2.60938C2.26344 19.4375 1.97656 19.1506 1.97656 18.8047C1.97656 18.4588 2.26344 18.1719 2.60938 18.1719H17.7969C18.1428 18.1719 18.4297 18.4588 18.4297 18.8047C18.4297 19.1506 18.1428 19.4375 17.7969 19.4375Z" fill="#532E60"/>
                                          <path opacity="0.4" d="M16.1262 3.8114C14.4893 2.17452 12.8862 2.13234 11.2071 3.8114L10.1862 4.83234C10.1018 4.91671 10.0681 5.05171 10.1018 5.16984C10.7431 7.40577 12.5318 9.19452 14.7677 9.83577C14.8015 9.84421 14.8352 9.85265 14.869 9.85265C14.9618 9.85265 15.0462 9.8189 15.1137 9.7514L16.1262 8.73046C16.9615 7.90359 17.3665 7.10202 17.3665 6.29202C17.3749 5.45671 16.9699 4.64671 16.1262 3.8114Z" fill="#532E60"/>
                                          <path d="M13.2494 10.6037C13.0047 10.4856 12.7685 10.3675 12.5406 10.2325C12.355 10.1228 12.1778 10.0047 12.0006 9.87811C11.8572 9.78529 11.6885 9.65029 11.5281 9.51529C11.5113 9.50686 11.4522 9.45623 11.3847 9.38873C11.1063 9.15248 10.7941 8.84873 10.5156 8.51123C10.4903 8.49436 10.4481 8.43529 10.3891 8.35936C10.3047 8.25811 10.1613 8.08936 10.0347 7.89529C9.93346 7.76873 9.81533 7.58311 9.70564 7.39748C9.57064 7.16967 9.45252 6.94186 9.33439 6.70561C9.21627 6.45248 9.12346 6.20779 9.03908 5.97998L3.74033 11.2787C3.63064 11.3884 3.52939 11.5994 3.50408 11.7428L3.04845 14.9744C2.96408 15.5481 3.12439 16.0881 3.47877 16.4509C3.78252 16.7462 4.20439 16.9065 4.66002 16.9065C4.76127 16.9065 4.86252 16.8981 4.96377 16.8812L8.20377 16.4256C8.35564 16.4003 8.56658 16.299 8.66783 16.1894L13.9666 10.8906C13.7303 10.8062 13.5025 10.7134 13.2494 10.6037Z" fill="#532E60"/>
                                          </svg>
                                           Change Profile Picture                                            </a>
                              </div> -->

                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="mandatory-application m-4">
                <div class="inside-out p-4">
                    <div class="container pt-4">

                        <div [formGroup]="vendorForm" *ngIf="vendorForm">

                            <div class="prime-address">
                                <div class="address-title mb-4">
                                    <h4 class="fw-bold">Account Details</h4>
                                </div>
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="company-name-input" class="form-label fw-bold mb-2">{{vendor?.vendorType == vendorType.Individual ? "Person Name" : "Company Name"}}</label>
                                            <input readonly type="text" formControlName="vendorName" class="form-control rounded-4 bg-light p-2" id="company-name-input" [placeholder]="vendor?.vendorType == vendorType.Individual ? 'Enter your Person Name' : 'Enter your Company Name'">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="company-person-name-input" class="form-label fw-bold mb-2">Company Person Name</label>
                                            <input type="text" formControlName="contactPerson" class="form-control rounded-4 bg-light p-2" id="company-person-name-input" readonly placeholder="Enter your Company Person Name">
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="email-input" class="form-label fw-bold mb-2">Email</label>
                                            <input type="email" formControlName="email" class="form-control rounded-4 bg-light p-2" id="email-input" placeholder="Enter your Email" readonly>
                                        </div>
                                        <div class="email-details1 mt-2">
                                            <p class="mb-0">To change your email address, please contact the Bidaya Procurement department.</p>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="country-input" class="form-label fw-bold mb-2" appRequiredField="country">Country</label>
                                            <select class="form-control rounded-4 bg-light p-2" formControlName="country" id="country-input">
                                                <option value="" selected disabled>Choose Country</option>
                                                <option
                                                    *ngFor="let country of Countries"
                                                    [value]="country.countryRegionId">
                                                    {{ country.countryName }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <app-mobile-input [form]="vendorForm"></app-mobile-input>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 d-flex justify-content-end">
                                        <button type="button" class="btn btn-next" (click)="onSubmitVendor()">Update</button>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <hr>

                        <div [formGroup]="passwordForm" *ngIf="passwordForm" autocomplete="off">
                            <div class="secondary-address">
                                <div class="address-title mb-4">
                                    <h4 class="fw-bold mb-2">Change Password</h4>
                                    <p class="email-details1 mb-0">We recommend avoiding overly simplistic passwords to ensure that your account and information are secure.</p>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="new-password-input-secondary" class="form-label fw-bold mb-2" appRequiredField="newPassword">New Password</label>
                                            <input type="password" formControlName="newPassword" class="form-control rounded-4 bg-light p-2" id="new-password-input-secondary" placeholder="Enter your New Password">
                                            <div *ngIf="passwordForm.get('newPassword')?.invalid && (passwordForm.get('newPassword')?.dirty || passwordForm.get('newPassword')?.touched)" class="text-danger mt-1">
                                                <small *ngIf="passwordForm.get('newPassword')?.errors?.['custom']">{{ passwordForm.get('newPassword')?.errors?.['custom'] }}</small>
                                                <small *ngIf="passwordForm.get('newPassword')?.errors?.['required']">This field is required</small>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="new-password-again-input-secondary" class="form-label fw-bold mb-2" appRequiredField="confirmNewPassword">New Password Again</label>
                                            <input type="password" formControlName="confirmNewPassword" class="form-control rounded-4 bg-light p-2" id="new-password-again-input-secondary" placeholder="Enter your New Password Again">
                                            <div *ngIf="passwordForm.get('confirmNewPassword')?.invalid && (passwordForm.get('confirmNewPassword')?.dirty || passwordForm.get('confirmNewPassword')?.touched)" class="text-danger mt-1">
                                                <small *ngIf="passwordForm.get('confirmNewPassword')?.errors?.['required']">This field is required</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 d-flex justify-content-end">
                                        <button type="button" class="btn btn-next" (click)="onSubmitVendorPassword()">Confirm Password Changes</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

<app-shared-otp-dialog></app-shared-otp-dialog>
